<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FlexRow',
  props: {
    space: {
      type: [Number, String],
      default: 1,
    },
    justify: {
      type: String,
      default: 'start',
    },
    align: {
      type: String,
      default: 'start',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    flexGrow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      const list = ['d-flex', 'flex-row', `space-${this.space}`]
      list.push(`align-${this.align}`)
      list.push(`justify-${this.justify}`)
      if (this.wrap) {
        list.push('flex-wrap')
      }
      if (this.fullWidth) {
        list.push('full-width')
      }
      if (this.fullHeight) {
        list.push('full-height')
      }
      if (this.flexGrow) {
        list.push('flex-grow-1')
      }
      return list
    },
  },
}
</script>

<style scoped>
.flex-row.space-0 > *:not(:last-child) {
  margin-right: 0;
}
.flex-row.space-half > *:not(:last-child) {
  margin-right: 4px;
}
.flex-row.space-1 > *:not(:last-child) {
  margin-right: 8px;
}
.flex-row.space-2 > *:not(:last-child) {
  margin-right: 16px;
}
.flex-row.space-3 > *:not(:last-child) {
  margin-right: 24px;
}
.flex-row.space-4 > *:not(:last-child) {
  margin-right: 32px;
}
.flex-row.space-5 > *:not(:last-child) {
  margin-right: 40px;
}
.flex-row.space-6 > *:not(:last-child) {
  margin-right: 48px;
}
.flex-row.space-7 > *:not(:last-child) {
  margin-right: 56px;
}
.flex-row.space-8 > *:not(:last-child) {
  margin-right: 64px;
}
.flex-row.space-9 > *:not(:last-child) {
  margin-right: 72px;
}
.flex-row.space-10 > *:not(:last-child) {
  margin-right: 80px;
}
.flex-row.space-11 > *:not(:last-child) {
  margin-right: 88px;
}
.flex-row.space-12 > *:not(:last-child) {
  margin-right: 96px;
}
.flex-row.space-24 > *:not(:last-child) {
  margin-right: 192px;
}
.full-width {
  flex-grow: 1;
}
.full-height {
  height: 100%;
}
</style>
